import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogIn, AlertCircle } from "lucide-react";
import { signInWithGoogle } from "../../services/auth";

export const LoginView: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = async () => {
    setError(null);
    setLoading(true);
    try {
      await signInWithGoogle();
      navigate("/");
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : "Failed to sign in with Google.";
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-12 dark:bg-slate-950 sm:px-6 lg:px-8">
      <div className="glass w-full max-w-md space-y-8 rounded-2xl border border-slate-200/80 bg-white/90 p-8 shadow-xl dark:border-slate-800/80 dark:bg-slate-900/90">
        <div className="text-center">
          <img
            src="/mlc-logo.png"
            alt="Multilingual Connections"
            className="mx-auto h-12 w-12 object-contain"
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src = "/favicon.png";
            }}
          />
          <h2 className="mt-4 text-2xl font-extrabold tracking-tight text-slate-900 dark:text-white">
            MLC Proposal HQ
          </h2>
          <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">
            Sign in with your Multilingual Connections Google Workspace account
          </p>
        </div>

        {error && (
          <div className="flex items-start gap-2.5 rounded-lg border border-red-200 bg-red-50/80 p-3.5 text-xs text-red-700 dark:border-red-900/50 dark:bg-red-950/40 dark:text-red-300">
            <AlertCircle className="h-4 w-4 shrink-0 text-red-500" />
            <span>{error}</span>
          </div>
        )}

        <div className="mt-6">
          <button
            type="button"
            onClick={handleSignIn}
            disabled={loading}
            className="btn-animate flex w-full items-center justify-center gap-3 rounded-xl bg-[#2ba5b5] px-4 py-3 text-sm font-semibold text-white shadow-md hover:bg-[#238997] focus:outline-hidden disabled:opacity-50"
          >
            <LogIn className="h-4 w-4" />
            <span>{loading ? "Signing in..." : "Sign In with Google SSO"}</span>
          </button>
        </div>

        <p className="text-center text-xs text-slate-400">
          Restricted to authorized{" "}
          <strong className="text-slate-600 dark:text-slate-300">@mlconnections.com</strong> staff.
        </p>
      </div>
    </div>
  );
};
